import { Check } from 'lucide-react';
import { Toaster } from 'sonner';

/**
 * 토스트가 서는 자리 — 상태바 바로 **밑**이다. 상단 바 밑으로 내리면 화면의 첫 입력 칸을
 * 덮는다(프로필 수정에서 저장 직후 닉네임 칸이 가려졌다). 상단 바가 없는 화면(홈·MY)에서도
 * 같은 높이에 선다 — 화면마다 자리가 달라지지 않는다.
 */
const TOAST_OFFSET = { top: 'calc(var(--safe-area-top, 0px) + 0.5rem)' };

/** 판의 모양 — 스펙이 값을 본다(jsdom 은 `var()` 가 든 `background` 를 인라인 스타일에서 버린다). */
export const TOAST_STYLE = {
  background: 'var(--bk-900)',
  color: '#fff',
  border: 'none',
  borderRadius: '16px',
  fontSize: '15px',
  fontWeight: 500,
  lineHeight: 1.4,
  letterSpacing: '-0.075px',
} as const;

/**
 * 앱의 토스트(Figma 의견 남기기 `제출 완료` 토스트) — 어두운 판 · 흰 15px · 16px 모서리.
 * 모양은 **여기 한 곳**에서 정한다: 부르는 쪽이 `style` 을 넘기면 화면마다 다른 토스트가
 * 생긴다(전에는 의견 제출만 어두운 판이고 나머지는 sonner 기본 흰 판이었다).
 *
 * - 글꼴은 앱의 것(`font-sans`)이다 — sonner 는 토스터에 시스템 글꼴을 직접 박아 두어
 *   `inherit` 으로는 안 바뀐다(측정: `ui-sans-serif, system-ui`). 토스트에 클래스로 건다.
 * - **끝났다는 알림**은 `toast.success` 로 부른다 — 라임 체크가 붙는다(저장·제출).
 *   그 밖의 안내는 `toast()` 다(아이콘 없음).
 * - `richColors` 는 쓰지 않는다 — 종류마다 판 색이 달라져 모양이 다시 갈라진다. 오류
 *   (`toast.error`)도 같은 판에 sonner 의 오류 아이콘만 붙는다.
 *
 * 폰 너비(≤600px)에서 sonner 는 `offset` 이 아니라 `mobileOffset` 을 쓰고, 안 넘기면 16px
 * 고정이라 상태바 안에서 뜬다(안전 영역을 모른다) — 둘 다 넘긴다. `{ top }` 만 주어 좌우는 기본값.
 */
export const AppToaster = () => (
  <Toaster
    position="top-center"
    offset={TOAST_OFFSET}
    mobileOffset={TOAST_OFFSET}
    icons={{
      success: (
        <Check
          className="h-5 w-5 text-[var(--toast-check)]"
          aria-hidden="true"
        />
      ),
    }}
    toastOptions={{
      style: TOAST_STYLE,
      // sonner 의 아이콘 칸은 16px 에 왼쪽 여백 -3px 이다 — 시안의 체크는 20px 이라 칸을
      // 넓히고 여백을 0 으로 돌려 판의 16px 패딩에 맞춘다.
      classNames: { toast: '!font-sans', icon: '!ml-0 !h-5 !w-5' },
    }}
  />
);
